import axios from "axios";
import axiosRetry from "axios-retry";

import StorageUtil, { KEYS } from "helpers/utils/StorageUtil";
import config from "config";
import { axiosRetryConfig } from "./GenericAPI";

export default class BaseSeparatorAPI {
  /**Métodos get */
  static async get(endpoint: string, data = {}) {
    const requestConfig = { params: data };
    return await api.get(endpoint, requestConfig);
  }

  /**Métodos post */
  static async post(endpoint: string, data = {}) {
    return await api.post(endpoint, data);
  }

  /**Método Put */
  static async put(endpoint: string, data = {}) {
    return await api.put(endpoint, data);
  }

  /**Método Patch */
  static async patch(endpoint: string, data = {}) {
    return await api.patch(endpoint, data);
  }

  /**Método delete */
  static async delete(endpoint: string, data = {}) {
    return await api.delete(endpoint, { data });
  }
}

const api = axios.create({
  baseURL: config.url,
});

api.interceptors.request.use(
  (config) => {
    let token = StorageUtil.getItem(KEYS.SEPARATOR_TOKEN);
    const companyUuid = StorageUtil.getItem(KEYS.COMPANY_UUID);

    if (!token) token = StorageUtil.getItem(KEYS.LOCKER_TOKEN);

    config.headers.set(
      'Content-Type',
      config.data instanceof FormData
        ? "multipart/form-data; charset=utf-8"
        : "application/json; charset=utf-8"
    );
    config.headers.set('accept', "*/*");
    config.headers.set('X-Company-UUID', companyUuid);

    if (token) {
      config.headers.Authorization = `Token ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosRetry(api, axiosRetryConfig);

